import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    ClientName: {
      validations: []
    },
    operation: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
      ]
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
      },
    SiteName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
       },   
    subeventcomments: {
      validations: []
    },
    EventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    PlannedGuestCount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },  
    StartTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    }, 
    EndTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
      },
    eventextra1: {
      validations: []
    },
    eventextra2: {
      validations: []
      },
    eventextra3: {
      validations: []
    },   
    eventextra4: {
      validations: []
      },   
    eventextra5: {
      validations: []
      },   
    eventextra6: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Master MGM Resorts',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
       {
      fields: [
        {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Department:',
          options: [
            {label: 'Catering Sales' , value: 'Catering Sales'},
            {label: 'EMM' , value: 'EMM'},
          ],
          mapping: 'operation'
        }
      ]
    },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'MGM Representative First Name:*',
            mapping: 'FirstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'MGM Representative Last Name:*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'MGM Representative Email Address:*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'MGM Property:*',
            options: [
              { label: 'Mandalay Bay', value: 'Mandalay Bay - 3950 S Las Vegas Blvd, Las Vegas, NV 89119, USA'},
              { label: 'Luxor', value: 'Luxor - 3900 S Las Vegas Blvd, Las Vegas, NV 89119, USA'},
              { label: 'Cosmopolitan', value: 'Cosmopolitan - 3708 Las Vegas Blvd S, Las Vegas, NV 89109, USA'},
              { label: 'Aria Resort and Casino', value: 'Aria Resort and Casino - 3730 S Las Vegas Blvd, Las Vegas, NV 89158, USA'},
              { label: 'Bellagio Hotel and Casino', value: 'Bellagio Hotel and Casino - 3600 S Las Vegas Blvd, Las Vegas, NV 89109, USA'},
              { label: 'New York New York  Hotel and Casino', value: 'New York New York  Hotel and Casino - 3790 S Las Vegas Blvd, Las Vegas, NV 89109, USA'},
              { label: 'MGM Grand', value: 'MGM Grand - 3799 S Las Vegas Blvd, Las Vegas, NV 89109, USA'},
              { label: 'Beau Rivage Resort and Casino', value: 'Beau Rivage Resort and Casino - 875 Beach Blvd, Biloxi, MS 39530, USA'},
              { label: 'MGM Grand Detroit', value: 'MGM Grand Detroit - 1777 3rd Ave, Detroit, MI 48226, USA'},
              { label: 'MGM National Harbor', value: 'MGM National Harbor - 101 MGM National Ave, Oxon Hill, MD 20745, USA'},
              { label: 'MGM Springfield', value: 'MGM Springfield - One MGM Wy, Springfield, MA 01103, USA'},
              { label: 'MGM Borgata', value: 'MGM Borgata - 1 Borgata Way, Atlantic City, NJ 08401, USA'},
              { label: 'Park MGM Casino and Resort', value: 'Park MGM Casino and Resort - 3770 S Las Vegas Blvd, Las Vegas, NV 89109, USA'},
              { label: 'NOMAD', value: 'NOMAD - 3772 S Las Vegas Blvd, Las Vegas, NV 89109, USA'},
              { label: 'Excalibur Hotel and Casino', value: 'Excalibur Hotel and Casino - 3850 S Las Vegas Blvd, Las Vegas, NV 89109, USA'},
              { label: 'W Las Vegas', value: 'W Las Vegas - 3940 S Las Vegas Blvd W, Las Vegas, NV 89119, USA'},
            ],
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Specific Location/Location Instructions:',
            mapping: 'subeventcomments',
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count:*',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Start Time:*',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00'},
              { label: '10:30AM', value: '10:30:00'},
              { label: '11:00AM', value: '11:00:00'},
              { label: '11:30AM', value: '11:30:00'},
              { label: '12:00PM', value: '12:00:00'},
              { label: '12:30PM', value: '12:30:00'},
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00'}
            ],
            mapping: 'StartTime'
         }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event End Time:*',
            options: [
              { label: '6:00AM', value: '06:00:00' },
              { label: '6:30AM', value: '06:30:00' },
              { label: '7:00AM', value: '07:00:00' },
              { label: '7:30AM', value: '07:30:00' },
              { label: '8:00AM', value: '08:00:00' },
              { label: '8:30AM', value: '08:30:00' },
              { label: '9:00AM', value: '09:00:00' },
              { label: '9:30AM', value: '09:30:00' },
              { label: '10:00AM', value: '10:00:00'},
              { label: '10:30AM', value: '10:30:00'},
              { label: '11:00AM', value: '11:00:00'},
              { label: '11:30AM', value: '11:30:00'},
              { label: '12:00PM', value: '12:00:00'},
              { label: '12:30PM', value: '12:30:00'},
              { label: '1:00PM', value: '13:00:00' },
              { label: '1:30PM', value: '13:30:00' },
              { label: '2:00PM', value: '14:00:00' },
              { label: '2:30PM', value: '14:30:00' },
              { label: '3:00PM', value: '15:00:00' },
              { label: '3:30PM', value: '15:30:00' },
              { label: '4:00PM', value: '16:00:00' },
              { label: '4:30PM', value: '16:30:00' },
              { label: '5:00PM', value: '17:00:00' },
              { label: '5:30PM', value: '17:30:00' },
              { label: '6:00PM', value: '18:00:00' },
              { label: '6:30PM', value: '18:30:00' },
              { label: '7:00PM', value: '19:00:00' },
              { label: '7:30PM', value: '19:30:00' },
              { label: '8:00PM', value: '20:00:00' },
              { label: '8:30PM', value: '20:30:00' },
              { label: '9:00PM', value: '21:00:00' },
              { label: '9:30PM', value: '21:30:00' },
              { label: '10:00PM', value: '22:00:00'}
            ],
            mapping: 'EndTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Type of Cocktails:',
            mapping: 'eventextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Min Guaranteed Total Cocktails:',
            mapping: 'eventextra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Service Requested:',
            options: [
              { label: 'Cocktails Only' , value: 'Cocktails Only'},
              { label: 'Specialized Bar Program', value: 'Specialized Bar Program'},
            ],
            mapping: 'eventextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Specialized Service:',
            options: [
              { label: 'None', value: 'None'},
              { label: 'Salt & Citrus', value: 'Salt & Citrus'},
              { label: 'Smoked Cocktail Station', value: 'Smoked Cocktail Station'},
              { label: 'Origami Bar', value: 'Origami Bar'},
              { label: 'Speak Easy', value: 'Speak Easy'},
              { label: 'Chakra Bar', value: 'Chakra Bar'},
              { label: 'Full Bar Bespoke', value: 'Full Bar Bespoke'},
              { label: 'Molecular Cocktails', value: 'Molecular Cocktails'},
              { label: 'Tray Pass Services', value: 'Tray Pass Services'},
              { label: 'SIPMI Live', value: 'SIPMI Live'},
              { label: 'SIPMI Preset', value: 'SIPMI Preset'},
              { label: 'Apothecary', value: 'Apothecary'},
              { label: 'Martini Station', value: 'Martini Station'},
              { label: 'Negroni Fountain and Station', value: 'Negroni Fountain and Station'},
              { label: 'Other – provide details in notes below', value: 'Other – provide details in notes below'},
            ],
            mapping: 'eventextra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Hall Number:',
            mapping: 'eventextra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Booth Number:',
            mapping: 'eventextra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Event Details and Requests:',
            mapping: 'Notes'
          }
        ]
      }, 
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT FOR QUOTE'
          }
        ]
      }
    ]
  },
  info: {
    title: 'The Grand Bevy Contact Form - MGM',
    formId: '435',
    clientKey: '2392BF2B-C921-4C97-B0FD-063F83BBB4F6',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
